import axios from 'axios';
import React, { useEffect, useCallback, useState } from 'react';
import OrgChart from './OrgChart';
import { useSelector } from 'react-redux';
import PuffLoader from 'react-spinners/PuffLoader';
import { css } from "@emotion/react";
import Nav from './Nav';


const override = css`
    display: block;
    margin: auto;
    border-color: red;
`;

const ReferralTree = () => {
    const address = useSelector((state) => state.address.value);
    const [isLoading, setLoading] = useState(true);
    const [treeData, setTreeData] = useState(null);

    const getUserTreeData = useCallback(async () => {    
        axios.post('api/getUserReferralTreeData', {
            address: address,
        })
        .then((res) => {
            res.data.map(n =>{
                n.tags = ['t' + n.deposit];
                return n;
            });

            console.log(res.data);

            setTreeData(res.data);
            setTimeout(()=>{
                 setLoading(false);
            }, 300);
        })
        .catch((err) => {
            setLoading(false);
            if(err.response){
                console.log(err.response);
            }
        })
    }, [setTreeData, setLoading, address]);

    useEffect(() => {
        getUserTreeData();        
    }, [getUserTreeData])

    function Tree(){        
        let nodes = treeData;        
        return(
            <div><OrgChart nodes={nodes} type="referral" /></div>
        )
    }
    function Loading(){              
        return(
            <PuffLoader color="#fff" loading={true} css={override} size={50} />
        )
    }

    return(
        <div className="tree-container">
            <div className="tree-content">                
                    {/* <div className="title">
                        <p className="tree-title">Referral Tree</p>
                    </div> */}
                    <div className="tree-wrap" style={{ display: isLoading ? "none" : "block" }}>                        
                        <Tree></Tree>                       
                    </div>
                    <div className="tree-wrap" style={{ display: isLoading ? "flex" : "none", justifyContent: "center"}}>  
                        <Loading></Loading>
                    </div>
                
            </div>
            <Nav/>
        </div>
    )   
}
    
export default ReferralTree;